import React from 'react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import AboutSection from '../../components/AboutSection';
import SEO from '../../components/SEO';
import { useLanguage } from '../../i18n/LanguageContext';

const About = () => {
  const { t } = useLanguage();
  const pageStyle = {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%)',
    paddingTop: '4rem'
  };

  const containerStyle = {
    maxWidth: '72rem',
    margin: '0 auto',
    padding: '2rem 1.5rem'
  };

  const headerStyle = {
    textAlign: 'center' as const,
    marginBottom: '3rem'
  };

  const titleStyle = {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: 'white',
    marginBottom: '1rem'
  };

  const highlightStyle = {
    color: '#dfa926'
  };

  const descriptionStyle = {
    fontSize: '1.25rem',
    color: '#d1d5db',
    maxWidth: '48rem',
    margin: '0 auto 3rem auto',
    lineHeight: '1.6'
  };

  return (
    <div style={pageStyle}>
      <SEO
        title={t('seo.about.title')}
        description={t('seo.about.description')}
        canonicalPath="/about"
        keywords={t('seo.about.keywords')}
      />
      <Navigation />
      <h1 style={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0
      }}>
        {t('seo.about.title')}
      </h1>
      <AboutSection />
      <Footer />
    </div>
  );
};

export default About;
